import React from 'react';
import WithSideBarAndNavBar from '../../layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import ImageListOfEmployees from '../../assets/images/list-of-emoloyees.png';
import ImageTrasnferOfMgt from '../../assets/images/transfer-of-mgt.png';
import { useNavigate } from 'react-router-dom';

import './salarySpecification.scss';

const SalarySpecCard = ({ image, title }: { image?: string; title?: string }) => {
  return (
    <div className="salarySpecCard">
      <div className="imageContainer">
        <img src={image} alt="" />
      </div>
      <div className="title">{title}</div>
    </div>
  );
};

const salarySpecification: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateEmpList = () => {
    navigate(`/salary-specification-emp-list`);
  };

  const handleNavigateTransferOfMgt = () => {
    navigate(`/salary-specification-transfer-of-mgt`);
  };

  return (
    <WithSideBarAndNavBar>
      <div className="salary-specs">
        <div className="salary-specs__head">급여명세서</div>

        <div className="salary-specs__cards">
          <button className="salary-specs__cards__list-of-employees" onClick={handleNavigateEmpList}>
            <img src={ImageListOfEmployees} alt="" />
          </button>
          <button className="salary-specs__cards__transfer-of-mgt" onClick={handleNavigateTransferOfMgt}>
            <img src={ImageTrasnferOfMgt} alt="" />
          </button>
        </div>
      </div>
    </WithSideBarAndNavBar>
  );
};

export default salarySpecification;
